var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ textAlign: 'center' })},[_c('div',[_vm._v(" "+_vm._s(_vm.callbackText)+" ")]),_c('ve-pie',{attrs:{"data":_vm.chartData,"legend-position":"bottom","settings":_vm.settings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }